var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeader, mergeConfig, getRequestUrl, success, fail, getAxiosConfig } from './utils';
import instance from './instance';
import { delObjEmptyProVal } from '../utils/ways';
/**
 * Get 请求
 * @param serviceName 请求地址 | 接口path
 * @param param 接口参数
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export function axiosGet(serviceName, param, extraConfig, version) {
    if (param === void 0) { param = {}; }
    if (extraConfig === void 0) { extraConfig = {}; }
    if (version === void 0) { version = 1; }
    return __awaiter(this, void 0, Promise, function () {
        var customHeader, config, requestUrl, axiosConfig, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeader(version)];
                case 1:
                    customHeader = _a.sent();
                    instance.defaults.headers = __assign(__assign({}, instance.defaults.headers), customHeader);
                    config = mergeConfig(extraConfig);
                    requestUrl = getRequestUrl(serviceName, config);
                    axiosConfig = getAxiosConfig(config, {
                        // params: delObjEmptyProVal(param)
                        params: config.isDelObjEmptyProVal ? delObjEmptyProVal(param) : param,
                    });
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, instance.get(requestUrl, axiosConfig)];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, success(response, config)];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, fail(err_1, config)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Post 请求
 * @param serviceName 请求地址 | 接口path
 * @param data 接口参数
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export function axiosPost(serviceName, data, extraConfig, version) {
    if (data === void 0) { data = {}; }
    if (extraConfig === void 0) { extraConfig = {}; }
    if (version === void 0) { version = 1; }
    return __awaiter(this, void 0, Promise, function () {
        var customHeader, config, requestUrl, axiosConfig, response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeader(version)];
                case 1:
                    customHeader = _a.sent();
                    instance.defaults.headers = __assign(__assign({}, instance.defaults.headers), customHeader);
                    config = mergeConfig(extraConfig);
                    requestUrl = getRequestUrl(serviceName, config);
                    axiosConfig = getAxiosConfig(config);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, instance.post(requestUrl, 
                        // delObjEmptyProVal(data),
                        config.isDelObjEmptyProVal ? delObjEmptyProVal(data) : data, axiosConfig)];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, success(response, config)];
                case 4:
                    err_2 = _a.sent();
                    return [2 /*return*/, fail(err_2, config)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Put 请求
 * @param serviceName 请求地址 | 接口path
 * @param data 接口参数
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export function axiosPut(serviceName, data, extraConfig, version) {
    if (data === void 0) { data = {}; }
    if (extraConfig === void 0) { extraConfig = {}; }
    if (version === void 0) { version = 1; }
    return __awaiter(this, void 0, Promise, function () {
        var customHeader, config, requestUrl, axiosConfig, response, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeader(version)];
                case 1:
                    customHeader = _a.sent();
                    instance.defaults.headers = __assign(__assign({}, instance.defaults.headers), customHeader);
                    config = mergeConfig(extraConfig);
                    requestUrl = getRequestUrl(serviceName, config);
                    axiosConfig = getAxiosConfig(config);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, instance.put(requestUrl, 
                        // delObjEmptyProVal(data),
                        config.isDelObjEmptyProVal ? delObjEmptyProVal(data) : data, axiosConfig)];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, success(response, config)];
                case 4:
                    err_3 = _a.sent();
                    return [2 /*return*/, fail(err_3, config)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Delete 请求
 * @param serviceName 请求地址 | 接口path
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export function axiosDelete(serviceName, param, extraConfig, version) {
    if (param === void 0) { param = {}; }
    if (extraConfig === void 0) { extraConfig = {}; }
    return __awaiter(this, void 0, Promise, function () {
        var customHeader, config, requestUrl, axiosConfig, response, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getHeader(version)];
                case 1:
                    customHeader = _a.sent();
                    instance.defaults.headers = __assign(__assign({}, instance.defaults.headers), customHeader);
                    config = mergeConfig(extraConfig);
                    requestUrl = getRequestUrl(serviceName, config);
                    axiosConfig = getAxiosConfig(config, {
                        // params: param
                        params: config.isDelObjEmptyProVal ? delObjEmptyProVal(param) : param,
                    });
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, instance.delete(requestUrl, axiosConfig)];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, success(response, config)];
                case 4:
                    err_4 = _a.sent();
                    return [2 /*return*/, fail(err_4, config)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
